import * as React from "react";
import LayoutGrid from "@tunnel-components/layouts/layout/index";
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";
import * as Utils from "@Cyclope-Utils/index";
import * as Enums from "@tunnel-enums/index";
import * as Paths from "@tunnel-enums/index";
import * as Lodash from "lodash";
// import * as cx from 'classnames';
import BoxDisplayHomeGrid from "@tunnel-components/@sharded/@widgets/display/home/component";
import BoxDisplaySeaGrid from "@tunnel-components/@sharded/@widgets/display/sae/component";
import BoxDisplayExtrationVideoGrid from "@tunnel-components/@sharded/@widgets/display/video/component";
import SnackBar from "@tunnel-components/@sharded/@widgets/snack-bar/succees/component";
import * as i18next from "i18next"; // traduction

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org" extractionVideoBoolean
   */
  const {
    loading,
    data,
    rulesVideoObject,
    extractionVideoBoolean,
    video,
    seaRadio,
    onSubmitSea,
    onChangeDisplaySea,
    onSubmitEVideo,
    onChangeVideoRules,
    noIncidents,
    btnloading,
    errorserver,
    displayArray,
    isNAN,
    displayaction,
    incidentDuration,
    radio,
    onChange,
    onChangeDisplayHome,
    onSubmit,
  } = props;
  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();

  /**
   * @description : retourne un boolean
   * @const
   * @name authorization
   * @type { boolean  }
   */
  const authorization: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.AFFICHAGEINCIDENTSPARAMUPDATE,
  ]);

  /**
   * @description : retourne un boolean
   * @const
   * @name editedSaeInformation
   * @type { boolean  }
   */
  const editedSaeInformation: boolean = Utils.simpleAuthorizationIsAllowed(
    User,
    [Enums.AuthorizationRightsEnums.AFFICHAGEUPDATESAE]
  );
  /**
   * @description : retourne un boolean ( )
   * @const
   * @name siteLoading
   * @type { boolean  }
   */
  const siteLoading: boolean =
    !Lodash.isUndefined(data) && !Lodash.isEmpty(data) && !Lodash.isNull(data);

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name lodash
   * @infos "https://reactjs.org"
   */
  return (
    <LayoutGrid
      snackbarError={isNAN}
      snackbar={displayaction}
      someTextError={i18next.t("veuillez rentrer un nombre entier positif")}
      someTextSuccees={i18next.t("les modifications ont ete enregistrees")}
      loading={loading}
      btnloading={btnloading}
      empty={noIncidents}
      error={errorserver}
    >
      {siteLoading && (
        <section className="tunnel-site animated fadeIn ">
          <BreadCrumb
            iconSupervision={true}
            links1={Paths.PathsNamesEnums.SYSTEMSHOME}
            title={i18next.t("supervision")}
            breadText1={i18next.t("affichage")}
          />
          <div className="contentAllSiteWithoutOnglet">
            <section className="columnsWithoutOnglet">
              <section className="content-wrapper">
                <section className="incident-items" id="columns">
                  <div className="displayIncidentRules">
                    <div className="disPlayAllIncidentsRules">
                      {/** div className="with-1-3-columns with-2-columns" */}
                      <div className="with-1-3-columns">
                        <BoxDisplayExtrationVideoGrid
                          item={video}
                          // rulesVideo={rulesVideo}
                          rulesVideo={rulesVideoObject}
                          onSubmit={onSubmitEVideo}
                          onChangeVideoRules={onChangeVideoRules}
                          disabled={false}
                          extractionVideoBoolean={extractionVideoBoolean}
                        />
                        <BoxDisplaySeaGrid
                          onSubmit={onSubmitSea}
                          checked={seaRadio}
                          disabled={!editedSaeInformation}
                          onChecked={onChangeDisplaySea}
                          style={{ cursor: "default" }}
                        />
                      </div>
                    </div>
                    <div className="disPlayAllIncidentsRules">
                      <div className="with-1-columns">
                        <BoxDisplayHomeGrid
                          displayArray={displayArray}
                          checked={radio}
                          onChecked={onChangeDisplayHome}
                          textValue={incidentDuration}
                          onChangeValue={onChange}
                          disabled={!authorization}
                          onSubmit={onSubmit}
                        />
                      </div>
                    </div>
                  </div>
                </section>
              </section>
            </section>
          </div>
        </section>
      )}
      <SnackBar
        style={{ backgroundColor: "#ed5b56" }}
        isVisible={extractionVideoBoolean}
        someTextSuccees={i18next.t("la valeur maximale est de 300 sec")}
      />
    </LayoutGrid>
  );
};
/** Valeurs par défaut des props */
Component.defaultProps = {
  incidentDuration: "",
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  loading?: any;
  data?: any;
  noIncidents?: any;
  btnloading?: any;
  errorserver?: any;
  displayArray?: any;
  isNAN?: any;
  displayaction?: any;
  incidentDuration?: any;
  radio?: any;
  onChange?: any;
  onChangeDisplayHome?: any;
  onSubmit?: any;
  video?: any;
  onSubmitEVideo?: any;
  onChangeVideoRules?: any;
  rulesVideoObject?: any;
  seaRadio?: any;
  onSubmitSea?: any;
  onChangeDisplaySea?: any;
  extractionVideoBoolean?: any;
}

/** @export HOC pure */
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/display/home/component.tsx